import { render, staticRenderFns } from "./DialogTemporaryTokenLogin.vue?vue&type=template&id=4852e0e1&scoped=true&"
import script from "./DialogTemporaryTokenLogin.vue?vue&type=script&lang=ts&"
export * from "./DialogTemporaryTokenLogin.vue?vue&type=script&lang=ts&"
import style0 from "./DialogTemporaryTokenLogin.vue?vue&type=style&index=0&id=4852e0e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4852e0e1",
  null
  
)

export default component.exports